import React from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import { Box } from "@material-ui/core";
import KeyManagementContainer from "@jumbo/Dashboards/KeyManagement";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.keyManagement"} />, isActive: true },
];

const KeyManagent = () => {
  return (
    <PageContainer
      heading={<IntlMessages id="pages.keyManagement" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <Box
            marginBottom={"10px"}
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <IntlMessages id="pages.keyManagement.description" />
          </Box>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <KeyManagementContainer />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default KeyManagent;
